import { managersReducer } from "./managers.reducer";
import { groupPerformanceReducer } from "./groupPerformance.reducer";

// eslint-disable-next-line
export default {
  managersReducer,
  groupPerformanceReducer,
};
